const USES = [
  {
    title: "Home improvements & renovations",
    desc: "Upgrade kitchens, bathrooms, or add living space.",
    testid: "use-renovations",
    image: "https://images.pexels.com/photos/36035073/pexels-photo-36035073.jpeg?auto=compress&cs=tinysrgb&w=900",
    imageAlt: "Modern kitchen remodel in progress",
  },
  {
    title: "New Roof",
    desc: "Protect your largest investment with a fresh new roof.",
    testid: "use-new-roof",
    image: "https://images.pexels.com/photos/33404248/pexels-photo-33404248.jpeg?auto=compress&cs=tinysrgb&w=900",
    imageAlt: "Professional roofer installing shingles on a new roof",
  },
  {
    title: "New Heating & Cooling System",
    desc: "Upgrade HVAC for comfort and lower energy bills.",
    testid: "use-hvac",
    image: "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&w=900",
    imageAlt: "Contractor installing a new heat pump and HVAC unit",
  },
  {
    title: "Debt consolidation",
    desc: "Consolidate higher-interest debt into one manageable payment.",
    testid: "use-debt",
    image: "https://images.pexels.com/photos/6964105/pexels-photo-6964105.jpeg?auto=compress&cs=tinysrgb&w=900",
    imageAlt: "Couple reviewing household bills with calculator and laptop",
  },
  {
    title: "Education expenses",
    desc: "Tuition, books, or back-to-school costs for your family.",
    testid: "use-education",
    image: "https://images.pexels.com/photos/7942526/pexels-photo-7942526.jpeg?auto=compress&cs=tinysrgb&w=900",
    imageAlt: "College graduates receiving diplomas at ceremony",
  },
  {
    title: "Emergency expenses",
    desc: "Be ready for the unexpected with accessible funds.",
    testid: "use-emergency",
    image: "https://images.pexels.com/photos/5998457/pexels-photo-5998457.jpeg?auto=compress&cs=tinysrgb&w=900",
    imageAlt: "Pediatrician examining a child patient in the clinic",
  },
  {
    title: "Major purchases & more",
    desc: "Weddings, vehicles, life milestones &mdash; the choice is yours.",
    testid: "use-major-purchases",
    image: "https://images.pexels.com/photos/35553660/pexels-photo-35553660.jpeg?auto=compress&cs=tinysrgb&w=900",
    imageAlt: "Bride and groom at outdoor wedding ceremony",
  },
];

export default function Uses() {
  return (
    <section
      id="uses"
      data-testid="uses-section"
      className="py-20 md:py-28 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12 md:mb-16">
          <p className="text-sm md:text-base font-semibold tracking-[0.22em] uppercase text-[#F26A21] mb-4">
            What you can do with a HELOC
          </p>
          <h2
            data-testid="uses-heading"
            className="font-display font-bold text-[#0A2F6B] text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight"
          >
            A HELOC may be used for almost anything that matters.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#475569] leading-relaxed">
            Tap into the equity you&rsquo;ve built &mdash; on your terms, and only when you need it.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6 reveal-stagger">
          {USES.map(({ icon: Icon, title, desc, testid, image, imageAlt }) => (
            <div
              key={title}
              data-testid={testid}
              className="group relative bg-white border border-[#E2E8F0] rounded-lg overflow-hidden hover:border-[#0A2F6B] hover:shadow-md transition-all duration-200 flex flex-col"
            >
              {image ? (
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-[#F1F5F9]">
                  <img
                    src={image}
                    alt={imageAlt || title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 ring-1 ring-inset ring-black/5" aria-hidden="true" />
                </div>
              ) : null}
              <div className="p-6 md:p-7">
                {!image && Icon ? (
                  <div className="w-11 h-11 rounded-md bg-[#F1F5F9] group-hover:bg-[#0A2F6B] flex items-center justify-center transition-colors duration-200 mb-5">
                    <Icon size={20} className="text-[#0A2F6B] group-hover:text-[#F26A21] transition-colors duration-200" strokeWidth={2.4} />
                  </div>
                ) : null}
                <h3 className="font-display font-semibold text-[#0A2F6B] text-lg leading-tight">
                  {title}
                </h3>
                <p
                  className="text-sm text-[#475569] mt-2 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: desc }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
